(function () {
    'use strict';

    angular
        .module('app')
        .factory('carouselservice', carouselservice);

    carouselservice.$inject = ['$http'];

    function carouselservice($http) {
        var service = {
            favorites: [],
            savedSearches: [],
            currentFavorites: [],
            currentSavedSearches: [],
            previousFavorite: previousFavorite,
            nextFavorite: nextFavorite,
            previousSavedSearch: previousSavedSearch,
            nextSavedSearch: nextSavedSearch
        };

        return service;

        function previousFavorite() {
            current
        }

        function nextFavorite() {

        }

        function previousSavedSearch() {

        }

        function nextSavedSearch() {

        }

    }
})();